<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :left-arrow="true"
      :z-index="10"
      :title="getNavTitle"
      @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <div class="title-bg">手机号</div>
      <van-cell-group class="group">
        <van-field
          v-model="cacheParams.mobile"
          type="number"
          maxlength="11"
          placeholder="请输入手机号"
          border
          clearable />
        <div
          v-if="cacheParams.type == 2"
          class="item-invite"
          style="margin-top: 15px">
          <van-field
            style="font-size: 13px"
            v-model="cacheParams.referrerCode"
            clearable
            readonly
            type="number"
            maxlength="11"
            input-align="right"
            label="填写邀请人"
            placeholder="请输入邀请人手机号/账户ID(选填)"
            @click="onSelectInviter" />
        </div>
      </van-cell-group>
      <van-button
        class="btn"
        color="rgb(206, 29, 35)"
        round
        type="warning"
        @click="onNextAction"
        v-preventReClick="500"
        >下一步</van-button
      >
    </div>
    <!-- 添加图片滑动解锁 -->
    <PhotoSlide
      ref="slideblock"
      @success="onSlideSuccess"
      sliderText="向右滑"
      :show="false"
      :showSlidePop.sync="showSlidePop"></PhotoSlide>
  </div>
</template>
  
  <script>
import PhotoSlide from "../../components/photoSlide.vue"
import * as CustApi from "@/api/cust"
import { CellGroup, Field, Toast } from "vant"
import session from "../../utils/session"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    PhotoSlide
  },
  data() {
    return {
      showSlidePop: false, // 是否显示滑块解锁框
      cacheParams: {
        type: 1, // 1 忘记密码 2 注册 3 登录后未设置密码 4 个人中心进入设置密码
        mobile: "",
        referrerCode: ""
      },
      smsForm: {
        loading: false
      }
    }
  },
  computed: {
    getNavTitle() {
      if (this.cacheParams.type == 1) {
        return "忘记密码"
      } else if (this.cacheParams.type == 2) {
        return "注册"
      } else if (this.cacheParams.type == 3) {
        return "设置密码"
      } else if (this.cacheParams.type == 4) {
        return "设置密码"
      } else {
        return ""
      }
    }
  },
  beforeMount() {
    this.cacheParams = session.getJson("RegisterAndForgetPwdKey")
    this.cacheParams.referrerCode = this.$route.query.referrerCode || ""
  },
  beforeDestroy() {},
  methods: {
    onNextAction() {
      if (this.cacheParams.mobile.length < 11) {
        this.$toast("请输入正确的手机号")
        return
      }
      if (!/^\d+$/.test(this.cacheParams.mobile)) {
        this.$toast("请输入正确的手机号")
        return
      }
      if (this.cacheParams.type == 1 || this.cacheParams.type == 2) {
        this.onExistByPhone()
      } else {
        this.showSlidePop = true
      }
    },
    onExistByPhone() {
      CustApi.existbyphone({ phone: this.cacheParams.mobile })
        .then((data) => {
          if (data) {
            if (this.cacheParams.type == 1) {
              this.showSlidePop = true
            } else {
              Toast("该手机号已注册！")
            }
          } else {
            if (this.cacheParams.type == 1) {
              Toast("该手机号未注册，请先注册！")
            } else {
              this.showSlidePop = true
            }
          }
        })
        .catch((e) => {})
    },
    //滑块验证方法
    onSlideSuccess() {
      this.showSlidePop = false
      this.$refs.slideblock.reset()
      this.onSendCode()
    },
    //请求验证码接口
    onSendCode() {
      this.smsForm.loading = true
      CustApi.sendcode(this.cacheParams.mobile)
        .then((data) => {
          this.smsForm.loading = false
          session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
          this.$router.push({
            name: "personalCenter-loginpwd2"
          })
        })
        .catch((e) => {
          this.smsForm.loading = false
          Toast(e.msg || e.message)
        })
    },
    onSelectInviter() {
      this.cacheParams.referrerCode = ""
      session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
      this.$router.push({
        name: "search_inviter"
      })
    }
  }
}
</script>
  
  <style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.title-bg {
  margin: 50px 20px;
  font-size: 20px;
  font-weight: 500;
}
.group {
  margin: 50px 40px;
  .van-field {
    border: 1px solid rgb(208, 211, 213);
    border-radius: 5px;
    font-size: 15px;
  }
}
.btn {
  margin: 0 40px;
  margin-top: 40px;
  height: 44px;
  width: calc(100vw - 80px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
.slide-content {
  margin-top: 88px;
  margin-left: calc(50vw - 180px);
}
</style>
  